module.exports = __webpack_public_path__ + "static/media/ico-tw.b42f3711.svg";